

export const ExpansionTimeMS = 500;

export const AccessoryLgWidth = 300;
export const AccessoryXlWidth = 360;
export const ViewMyDashboardWidth = 30;

export const LeaderboardRowHeight = 40;
export const LeaderboardRowHeightCompact = 32;
export const LeaderboardContentSize = LeaderboardRowHeight - 8;
export const LeaderboardContentSizeCompact = LeaderboardRowHeightCompact - 8;
export const LeaderboardRowGap = 6;
export const LeaderboardFinalRowGap = 12;
export const LeaderboardStartRowY = 36;

export enum PanelState {
    collapsed,
    expanded,
    collapsing,
    expanding
}